import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Minesweeper.
 *
 * Not a singleton — XP let you keep several boards on the go, and losing one
 * game should never take another down with it.
 *
 * The window is fixed: winmine.exe had no resize handle, it simply grew and
 * shrank to fit the board. `Minesweeper.tsx` reproduces that by resizing its
 * own window whenever the difficulty changes, and `defaultSize` below is what
 * that same arithmetic produces for Beginner — 9 × 9 tiles of 16px, plus the
 * casing, the status panel, the menu bar and the window's own frame. Keep the
 * two in step; the component is the source of truth.
 *
 * Takes no args.
 */
export const minesweeperApp: AppManifest = {
  id: 'minesweeper',
  name: 'Minesweeper',
  icon: '/assets/icons/minesweeper.svg',
  component: lazy(() => import('./Minesweeper')),

  defaultSize: { w: 174, h: 261 },
  resizable: false,
  maximizable: false,
  singleton: false,

  group: 'Games',
  titleFor: () => 'Minesweeper',
};
